import { useEffect, useState } from 'react';
import { Alert, Button, Card, Spin, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { GiftOutlined } from '@ant-design/icons';
import { Nav } from '../../components/Nav';
import {
    getPackageDestination,
    getPackageDocType,
    isAmountEntitlement,
    resolvePackageShare,
    selectPackageEntitlement,
} from '../../Service/packageEntitlements';

export default function PackageClaim() {
    const navigate = useNavigate();
    const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token'));
    const [item, setItem] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let active = true;
        if (!token) {
            setError('领取链接不完整，请让分享者重新发送链接。');
            setLoading(false);
            return;
        }
        resolvePackageShare(token)
            .then((data) => {
                if (active) setItem(data);
            })
            .catch((e) => {
                if (active) setError(e.message);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [token]);
    const begin = () => {
        try {
            const destination = getPackageDestination(item);
            selectPackageEntitlement(item);
            navigate(destination, { replace: true });
        } catch (e) {
            setError(e.message || '浏览器未能保存套餐，请允许本站使用会话存储后重试。');
        }
    };
    return (
        <div style={{ minHeight: '100vh', background: '#f8f6fc' }}>
            <Nav bgWhite hasBottomBorder />
            <Card style={{ maxWidth: 560, margin: '48px auto', width: 'calc(100% - 32px)' }}>
                <Spin spinning={loading}>
                    <GiftOutlined style={{ color: 'var(--ant-color-primary, #a277ee)', fontSize: 32 }} />
                    <Typography.Title level={2}>{isAmountEntitlement(item) ? '收到一张金额兑换码' : '收到一份写作套餐'}</Typography.Title>
                    {error ? (
                        <Alert type="warning" showIcon message={error} />
                    ) : (
                        item && (
                            <>
                                <Typography.Title level={4}>
                                    {item.redeemName || '毕业论文套餐'}
                                </Typography.Title>
                                <Typography.Paragraph>
                                    {isAmountEntitlement(item) ? '点击下方按钮开始填写内容。确认生成时按订单金额核验额度，兑换码仅可使用一次。' : '点击下方按钮开始填写内容，无需复制兑换码。确认生成时才使用本份套餐。'}
                                </Typography.Paragraph>
                                {isAmountEntitlement(item) || getPackageDocType(item) ? (
                                    <Button type="primary" size="large" block onClick={begin}>
                                        {isAmountEntitlement(item) ? '使用这张兑换码' : '使用这份套餐'}
                                    </Button>
                                ) : (
                                    <Alert
                                        type="info"
                                        showIcon
                                        message="此项是独立任务书或调查问卷"
                                        description={
                                            <span>
                                                请携下面的套餐凭证联系客服协助使用，当前不会扣减：
                                                <code style={{ overflowWrap: 'anywhere' }}>
                                                    {item.redeemCode}
                                                </code>
                                            </span>
                                        }
                                    />
                                )}
                            </>
                        )
                    )}
                    <Button type="link" onClick={() => navigate('/eightPieceSet')}>
                        查看套餐与使用说明
                    </Button>
                </Spin>
            </Card>
        </div>
    );
}
